'use strict';

import 'document-register-element';
import resizeStore from '../resize/resize.store';
import SplitText from 'SplitText';



export class MultiAudio extends HTMLElement {
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._active = null;

    this._player = this.querySelector('audio-player');
    const readImage = document.querySelector('.readImage');
    if (!this._player || !readImage) return;

    this._buttons = Array.from(this.querySelectorAll('.playlistButton')).map(el => {
      const obj = {
        el,
        src: el.dataset.audio,
        title: el.dataset.title,
        readImagePrimary: el.dataset.readprimary,
        readImageSecondary: el.dataset.readsecondary
      }

      if (el.classList.contains('active')) this._active = obj;

      el.addEventListener('click', () => {
        if (this._active) this._active.el.classList.remove('active');

        el.classList.add('active');
        this._active = obj;

        this._player.src = obj.src;
        this._player.title = obj.title;
        this._player.play();

        if (obj.readImagePrimary && obj.readImageSecondary) {
          readImage.innerHTML = `
            <source srcset='${obj.readImagePrimary}' type="image/webp">
            <img src='${obj.readImageSecondary}' alt=''>
          `;
        }
      });

      return obj;
    });
  }
  connectedCallback() {
  }
  disconnectedCallback() {
  }
}


window.customElements.define('multi-audio', MultiAudio);